/**
 * Transform pricing from raw response for Products
 *
 */
const getProductPricing = (financials, selectedTrim, hasError) => {
  const { models } = financials || {};
  if (!Array.isArray(models) || !models?.length) return null;

  const model = models[0];
  const targetTrim = model?.trims?.find(trim => trim?.id?.toString() === selectedTrim?.trimId);
  // find matching transmission with a fallback value
  const transmission =
    targetTrim?.transmissions?.find(tm => tm?.id?.toString() === selectedTrim?.transmissionId) ||
    targetTrim?.transmissions?.[0];
  const defaultExteriorColor = transmission?.exteriorColors?.[0];

  return {
    msrp: defaultExteriorColor?.msrp,
    sellingPrice: defaultExteriorColor?.sellingPrice,
    freightPdiCost: targetTrim?.freightPdiCost,
    levyTotal: transmission?.levyTotal,
    hasError,
    discount: {
      priceDiscountAmount: transmission?.priceDiscountAmount,
      msrpWithDiscount: defaultExteriorColor?.msrpWithDiscount,
      sellingPriceWithDiscount: defaultExteriorColor?.sellingPriceWithDiscount,
    },
  };
};

export default getProductPricing;
